import { Injectable } from "@angular/core";

import { of } from 'rxjs';
import { catchError, map, mergeMap, tap } from 'rxjs/operators';

import { Actions, createEffect, ofType } from "@ngrx/effects";

import { fetchTeamMembersListData, fetchTeamMembersListSuccess, fetchTeamMembersListFailure, blockTeamMember, blockTeamMemberSuccess, blockTeamMemberFailure, addTeamMember, addTeamMemberSuccess, addTeamMemberFailure, fetchUserAccessRights, fetchUserAccessRightsSuccess, fetchUserAccessRightsFailure } from "./teammember.actions";
import { AuthenticationService } from "../../core/services/auth.service";
import { ToastifyService } from "../../shared/toastify-service";
import { TeamService } from "../../core/services/team.service";
import { CommonAPIService } from "../../core/services/common-api.service";


@Injectable()
export class TeamMemberEffects {

  // TeamMember
  fetchTeamMemberData$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fetchTeamMembersListData),
      mergeMap(({isblocked, limit, skip}) =>
        this.restApiService.getMembersData(isblocked, limit, skip).pipe(
          map((membersdata) => {
            return fetchTeamMembersListSuccess({ memberdata: membersdata });
          }),
          catchError((error) =>
            of(fetchTeamMembersListFailure({ error }))
          )
        )
      ),
    ),
  );

  blockTeamMemberData$ = createEffect(() =>
    this.actions$.pipe(
      ofType(blockTeamMember),
      mergeMap(({ userguid, status }) =>
        this.commonApiService.blockUnblockUser(userguid, status).pipe(
          map(() => blockTeamMemberSuccess({ userguid: userguid })),
          catchError((error) => of(blockTeamMemberFailure({ error })))
        )
      )
    )
  );

  blockTeamMemberDataSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(blockTeamMemberSuccess),
        tap(action => {
          this.toastifyService.showSuccessMessage("TeamMember updated successfully.");
        })
      ),
    { dispatch: false }
  );

  blockTeamMemberDataFailure$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(blockTeamMemberFailure),
        tap((error: any) => {
          this.toastifyService.showErrorMessage(error.error.message);
        })
      ),
    { dispatch: false }
  );

  addTeamMemberData$ = createEffect(() =>
    this.actions$.pipe(
      ofType(addTeamMember),
      mergeMap(({ postdata }) =>
        this.restApiService.addTeamMember(postdata).pipe(
          map((member) => addTeamMemberSuccess({ teamMember: member.user })),
          catchError((error) => of(addTeamMemberFailure({ error })))
        )
      )
    )
  );

  addTeamMemberDataSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(addTeamMemberSuccess),
        tap(action => {
          this.toastifyService.showSuccessMessage("Sent invite successfully.");
        })
      ),
    { dispatch: false }
  );

  addTeamMemberDataFailure$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(addTeamMemberFailure),
        tap((error: any) => {
          this.toastifyService.showErrorMessage(error.error.message);
        })
      ),
    { dispatch: false }
  );

  fetchUserAccessRightsData$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fetchUserAccessRights),
      mergeMap(({guid}) =>
        this.restApiService.getMemberAccessRights(guid).pipe(
          map((accessrights) => {
            return fetchUserAccessRightsSuccess({ accessrights });
          }),
          catchError((error) =>
            of(fetchUserAccessRightsFailure({ error }))
          )
        )
      ),
    ),
  );

  constructor(
    private actions$: Actions,
    private restApiService: TeamService,
    private commonApiService: CommonAPIService,
    private authService: AuthenticationService,
    private toastifyService: ToastifyService
  ) { }
}